module.exports = __webpack_public_path__ + "static/media/magzine.4744d50f.jpg";